import { render, staticRenderFns } from "./ReviewResume.vue?vue&type=template&id=6533b655&scoped=true&"
import script from "./ReviewResume.vue?vue&type=script&lang=js&"
export * from "./ReviewResume.vue?vue&type=script&lang=js&"
import style0 from "./ReviewResume.vue?vue&type=style&index=0&id=6533b655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533b655",
  null
  
)

export default component.exports